import gql from 'graphql-tag'
import { graphql, ChildDataProps } from 'react-apollo'

export type InputProps = {}

export type Variables = {
  positionId: number
}

export type Response = {}

type ChildProps = ChildDataProps<InputProps, Response, Variables>

export const POSITION_IMAGE_QUERY = gql`
  query getPositionImage($positionId: Float!, $companyId: String) {
    getPositionImage(positionId: $positionId, companyId: $companyId)
  }
`

const withPositionQuery = graphql<InputProps, Response, Variables, ChildProps>(
  POSITION_IMAGE_QUERY,
  {
    name: 'positionData',
  },
)

export default withPositionQuery
